import React, { useState } from 'react'
import PropTypes from 'prop-types'

import axios from '../../dataClient/dataClient'
import { StyledDialog, FlexEndContainer, FlexDialogContent, FlexColumn } from '../styles/Containers'
import Button, { SecondaryButton } from '../common/Button'
import BodyText, { BoldFormTitle } from '../styles/Text'
import { ErrorMessage } from '../common/UserMessage'

function ResendResponseLinkButton({ foiId, onSuccess = () => {} }) {
  const [isVisible, setIsVisible] = useState(false)
  const [isLoading, setIsLoading] = useState(false)
  const [error, setError] = useState(false)

  const handleOpen = () => {
    setIsVisible(true)
    setError(false)
  }

  const handleClose = () => {
    setIsVisible(false)
    setError(false)
    setIsLoading(false)
  }

  async function handleConfirm() {
    setIsLoading(true)
    setError(false)

    axios
      .post(`/foi/${foiId}/resend-response`)
      .then(() => {
        handleClose()
        onSuccess()
      })
      .catch(e => {
        console.error('Failed to resend response link', e)
        setError(true)
        setIsLoading(false)
      })
  }

  return (
    <>
      <Button onClick={handleOpen}>Resend Response Link</Button>
      <StyledDialog fullWidth open={isVisible} onClose={handleClose} keepMounted={false}>
        <FlexDialogContent>
          <FlexColumn>
            <BoldFormTitle>Resend Response Link</BoldFormTitle>
            <BodyText>Are you sure you want to resend the response link to the requestor?</BodyText>
            {error && <ErrorMessage>There was an error resending the response link. Please try again.</ErrorMessage>}
            <FlexEndContainer>
              <SecondaryButton onClick={handleClose} disabled={isLoading}>
                Cancel
              </SecondaryButton>
              <Button onClick={handleConfirm} loading={isLoading}>
                Resend Link
              </Button>
            </FlexEndContainer>
          </FlexColumn>
        </FlexDialogContent>
      </StyledDialog>
    </>
  )
}

ResendResponseLinkButton.propTypes = {
  foiId: PropTypes.string.isRequired,
  onSuccess: PropTypes.func
}

export default ResendResponseLinkButton
